import { render, staticRenderFns } from "./comp-info.vue?vue&type=template&id=2652663c&scoped=true"
import script from "./comp-info.vue?vue&type=script&lang=js"
export * from "./comp-info.vue?vue&type=script&lang=js"
import style0 from "./comp-info.vue?vue&type=style&index=0&id=2652663c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652663c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/model/comp-info.vue
// module id = null
// module chunks = 